import { NgClass, NgIf } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Geolocation } from '@capacitor/geolocation';
import { ILatLon } from '@curbnturf/entities';
import { formatCoordinatesFormValue, IAddressForm, ICoordinatesForm } from '@curbnturf/form-helpers';
import { CoordinatesMapComponent } from '@curbnturf/map/src/lib/coordinates-map/coordinates-map.component';
import { MapModalComponent } from '@curbnturf/map/src/lib/map-modal/map-modal.component';
import { IonicModule, ModalController } from '@ionic/angular';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';

@Component({
  standalone: true,
  selector: 'curbnturf-location-optional',
  templateUrl: './location-optional.component.html',
  styleUrls: ['./location-optional.component.scss'],
  imports: [CoordinatesMapComponent, IonicModule, MapModalComponent, NgClass, NgIf, ReactiveFormsModule],
})
export class LocationOptionalComponent implements OnChanges, OnDestroy {
  @Input() addressForm: FormGroup<IAddressForm>;
  @Input() coordinatesForm: FormGroup<ICoordinatesForm>;
  @Input() coordinatesShow: boolean;

  simpleView = false;
  pointListSubject: Subject<ILatLon[]>;
  pointList$: Observable<ILatLon[]>;

  private subscriptions: Subscription[] = [];

  constructor(private modalController: ModalController) {
    this.pointListSubject = new BehaviorSubject([]);
    this.pointList$ = this.pointListSubject.asObservable();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.coordinatesForm.currentValue) {
      const coordinates = formatCoordinatesFormValue(this.coordinatesForm);
      if (coordinates) {
        this.pointListSubject.next([coordinates]);
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  async setCoordinatesToCurrent() {
    const location = await Geolocation.getCurrentPosition();
    this.setCoordinates({
      lat: location.coords.latitude,
      lon: location.coords.longitude,
    });
  }

  async getCoordinatesFromMap() {
    const modal = await this.modalController.create({
      component: MapModalComponent,
      componentProps: {
        pins$: this.pointList$,
        locationClicked: (coordinates: ILatLon) => this.locationClicked(coordinates),
      },
    });
    await modal.present();
  }

  locationClicked(coordinates: ILatLon) {
    this.setCoordinates(coordinates);
  }

  private setCoordinates(coordinates: ILatLon) {
    if (coordinates.lat && coordinates.lon) {
      this.coordinatesForm.setValue(coordinates);
      this.coordinatesForm.markAsDirty();

      this.pointListSubject.next([coordinates]);
    }
  }
}
